export enum Routes{
    PhotoRoute = '/photo-route',
    GettingTo = '/getting-to'
}
